import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

interface ImageRenderProps {
	imageUrl: string;
	fallBackUrl: string;
	loaderSize?: number;
	fallbackImageSize?: number;
	imageStyles?: React.CSSProperties;
	altText?: string;
}

export default function ImageRender({
	imageUrl,
	fallBackUrl,
	loaderSize = 20,
	fallbackImageSize = 120,
	imageStyles = {},
	altText = 'Image',
}: ImageRenderProps) {
	const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

	// useEffect(() => {
	// 	const fetchData = async () => {
	// 		try {
	// 			const response = await fetch(`${imageUrl}`);
	// 			if (response.ok) {
	// 				setStatus('success');
	// 			} else {
	// 				setStatus('error');
	// 			}
	// 		} catch (error) {
	// 			setStatus('error');
	// 		}
	// 	};

	// 	fetchData();
	// }, [imageUrl]);

	return (
		<div>
			{/* {status === 'loading' && <CircularProgress size={loaderSize} />}
			{status === 'success' && <img src={imageUrl} alt={altText} style={imageStyles} />}
			{status === 'error' && (
				<img width={fallbackImageSize} src={fallBackUrl} alt="Fallback Image" />
			)} */}
			<img
				style={imageUrl ? imageStyles : { ...imageStyles, width: fallbackImageSize }}
				src={imageUrl ? imageUrl : fallBackUrl}
				alt="product-image"
			/>
		</div>
	);
}
